import {
  Box,
  Button,
  Card,
  CardContent,
  Fade,
  Typography,
} from "@mui/material";
import AppButton from "../../components/button/AppButton";
import AppTextInput from "../../components/inputs/AppTextInput";
import { AppColors } from "../../constants/AppColors";
import { useForgotPasswordScreen } from "./hooks/useForgotPasswordScreen";

const ForgotPasswordScreen = () => {
  const vm = useForgotPasswordScreen();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: AppColors.background,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Fade in timeout={350}>
        <Card sx={{ width: "100%", maxWidth: 430, borderRadius: "24px" }}>
          <CardContent sx={{ p: 3 }}>
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: "18px",
                bgcolor: AppColors.primary,
                color: AppColors.textOnPrimary,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 2,
                fontWeight: 900,
                fontSize: 24,
              }}
            >
              RP
            </Box>

            <Typography variant="h4" sx={{ fontWeight: 900, mb: 1 }}>
              {vm.t("auth.forgotPassword")}
            </Typography>

            <Typography color="text.secondary" sx={{ mb: 3 }}>
              {vm.t("auth.forgotPasswordSubtitle")}
            </Typography>

            {vm.error ? (
              <Typography color="error" sx={{ fontWeight: 700, mb: 1.5 }}>
                {vm.error}
              </Typography>
            ) : null}

            {vm.successMessage ? (
              <Typography
                color="success.main"
                sx={{ fontWeight: 700, mb: 1.5 }}
              >
                {vm.successMessage}
              </Typography>
            ) : null}

            <Box component="form" onSubmit={vm.handleSubmit}>
              <AppTextInput
                label={vm.t("auth.email")}
                value={vm.email}
                onChange={(event) => vm.setEmail(event.target.value)}
                error={Boolean(vm.emailError)}
                helperText={vm.emailError}
                autoComplete="email"
              />

              <Box sx={{ mt: 2 }}>
                <AppButton
                  title={vm.t("auth.sendResetLink")}
                  type="submit"
                  loading={vm.loading}
                />
              </Box>
            </Box>

            <Box sx={{ mt: 2, textAlign: "center" }}>
              <Button
                variant="text"
                onClick={vm.goToLogin}
                disabled={vm.loading}
              >
                {vm.t("auth.backToLogin")}
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Fade>
    </Box>
  );
};

export default ForgotPasswordScreen;
